import Tab, { TabProps } from './Tab';

export type { TabProps };
export default Tab;
